<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 justify-content-center">

      <form #form="ngForm" (ngSubmit)="form.form.valid && login()" novalidate>
        <div class="row justify-content-center">
          <h3>{{"shared.login.title" | translate}}</h3>
        </div>

        <section>
          <div *ngIf="welcomeName" class="row justify-content-center">
            <h5>{{"shared.login.welcome-text" | translate}} {{welcomeName}}</h5>
          </div>
          <div class="row justify-content-center">
            <div *ngIf="phoneField" class="col-12 col-md-12 col-lg-6">
              <label>{{"shared.login.phone" | translate}}</label>
              <div class="input-group">
                <div class="dropdown">
                  <button
                    class="btn btn-primary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    (click)="toggleDropdown()"
                    aria-expanded="false">
                    {{ phoneCountryCode ? '+ ' + phoneCountryCode : '+ 1' }}
                  </button>
                  <ul
                    class="dropdown-menu"
                    [class.show]="isDropdownOpen"
                    aria-labelledby="dropdownMenuButton">
                    <li *ngFor="let item of countryCodes" (click)="selectCountry(item)" class="dropdown-item">
                      <img [src]="item.flag" class=" m-1 input-group-prepend" height="20" alt="{{item.country}}">
                      +{{ item.dialCode }} ({{ item.name }})
                    </li>
                  </ul>
                </div>

                <input type="tel" class="form-control" [mask]="getDialCodePhoneData(phoneCountryCode, configurationService.application).mask" name="cellphone" [(ngModel)]="phone" #phoneVal="ngModel" [ngClass]="inputFieldCss(phoneVal, form)" numbers>
                <app-field-error-display [control]="phoneVal" [form]="form"></app-field-error-display>
              </div>
            </div>
            <div *ngIf="emailField" class="col-12 col-md-12 col-lg-6">
              <label>{{"shared.login.email" | translate}}</label>
              <input type="email" class="form-control" name="username" [(ngModel)]="email" #emailVal="ngModel" [ngClass]="inputFieldCss(emailVal, form)" required app-email>
              <app-field-error-display [control]="emailVal" [form]="form"></app-field-error-display>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-6">
              <div class="form-group">
                <label>{{"shared.login.password" | translate}}</label>
                <div class="input-group">
                  <div class="input-group-append">
                    <button [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
                      type="button" (click)="togglePasswordVisibility()">

                      <i *ngIf="showPassword; else eyeSlash" class="fas fa-eye"></i>
                      <ng-template #eyeSlash>
                        <i class="fas fa-eye-slash"></i>
                      </ng-template>
                    </button>
                  </div>

                  <input [type]="showPassword ? 'text' : 'password'" class="form-control" name="pinValue" [(ngModel)]="password"
                    #passwordVal="ngModel" [minLength]="6" [ngClass]="inputFieldCss(passwordVal, form)" (blur)="handleBlurPassword()"
                    required>

                  <button *ngIf="password" class="btn btn-primary border-right" type="submit">
                    {{ "home.go" | translate }}
                  </button>
                </div>

                <div class="text-right">
                  <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
                  <input class="ml-2" type="checkbox" name="newNip" value="nip" [(ngModel)]="showPassword">
                </div>
                <div *ngIf="isPasswordInvalid" class="text-center mt-2">
                  <small>{{ "shared.login.forget-password" | translate }} <a routerLink="/passwordRecovery">{{ "shared.login.click-here" | translate }}</a></small>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isDropdownOpen" class="overlay" (click)="isDropdownOpen = false"></div>
        </section>

        <div class="col-12 text-right ">
          <br>
          <button type="submit" class="btn btn-primary">{{"shared.login.login_button" | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</div>
